const reports = {
    en: {
        "reports.title": "Reports & backup",
        "reports.exports": "Report exports",
        "reports.transactions": "Transactions (Excel)",
        "reports.financial": "Financial summary (Excel)",
        "reports.activity": "Activity log (Excel)",
        "reports.vehicles": "Vehicles (Excel)",
        "reports.containers": "Containers (Excel)",
        "reports.bookings": "Bookings (Excel)",
        "reports.download": "Download",
        "reports.backup": "Database backup",
        "reports.backupHint": "Full JSON snapshot of all data (passwords excluded). Admin only.",
        "reports.downloadBackup": "Download backup (JSON)",
    },
    ru: {
        "reports.title": "Отчёты и резервная копия",
        "reports.exports": "Экспорт отчётов",
        "reports.transactions": "Транзакции (Excel)",
        "reports.financial": "Финансовая сводка (Excel)",
        "reports.activity": "Журнал действий (Excel)",
        "reports.vehicles": "Автомобили (Excel)",
        "reports.containers": "Контейнеры (Excel)",
        "reports.bookings": "Брони (Excel)",
        "reports.download": "Скачать",
        "reports.backup": "Резервная копия БД",
        "reports.backupHint": "Полный снимок всех данных в JSON (без паролей). Только админ.",
        "reports.downloadBackup": "Скачать копию (JSON)",
    },
    geo: {
        "reports.title": "რეპორტები და სარეზერვო ასლი",
        "reports.exports": "რეპორტების ექსპორტი",
        "reports.transactions": "ტრანზაქციები (Excel)",
        "reports.financial": "ფინანსური შეჯამება (Excel)",
        "reports.activity": "აქტივობის ჟურნალი (Excel)",
        "reports.vehicles": "ავტომობილები (Excel)",
        "reports.containers": "კონტეინერები (Excel)",
        "reports.bookings": "ჯავშნები (Excel)",
        "reports.download": "ჩამოტვირთვა",
        "reports.backup": "ბაზის სარეზერვო ასლი",
        "reports.backupHint": "ყველა მონაცემის სრული JSON ასლი (პაროლების გარეშე). მხოლოდ ადმინი.",
        "reports.downloadBackup": "ასლის ჩამოტვირთვა (JSON)",
    },
};

export default reports;
